export default __webpack_public_path__ + "static/media/twitter.f045f417.svg";